import { GameConstants } from "../../GameConstants";
import { BoardManager } from "./BoardManager";
import { GameManager } from "../../GameManager";
import { AudioManager } from "../../AudioManager";
import { GameVars } from "../../GameVars";
import { TutorialLayer } from "../TutorialLayer";

export class PauseLayer extends Phaser.Group {

    private tutorialLayer: Phaser.Group;
    private audioOnButton: Phaser.Button;
    private audioOffButton: Phaser.Button;
    private tutorialButton: Phaser.Button;

    constructor(game: Phaser.Game) {

        super(game, null, "pause-layer");

        const tmpBackground = <Phaser.Sprite>this.create(0, 0, this.game.cache.getBitmapData(GameConstants.BLACK_SQUARE));
        tmpBackground.scale.set(GameConstants.GAME_WIDTH / GameConstants.BITMAP_SIZE, GameConstants.GAME_HEIGHT / GameConstants.BITMAP_SIZE);
        tmpBackground.alpha = 0;
        tmpBackground.inputEnabled = true;
        tmpBackground.events.onInputDown.add(function (): void {
            // no hacer nada
        }, this);

        const closeButton = new Phaser.Button(this.game, 5, 5, "texture_atlas_1", this.onClickClose, this);
        closeButton.setFrames("btn_resume", "btn_resume", "btn_resume", "btn_resume");
        closeButton.scale.y = GameVars.scaleY;
        this.add(closeButton);

        this.audioOnButton = new Phaser.Button(this.game,  GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOnButton.setFrames( "btn_sound_on", "btn_sound_on", "btn_sound_on", "btn_sound_on");
        this.audioOnButton.anchor.set(.5);
        this.audioOnButton.scale.y = GameVars.scaleY;
        this.add(this.audioOnButton);

        this.audioOffButton = new Phaser.Button(this.game, GameConstants.GAME_WIDTH - 50, 50 * GameVars.scaleY, "texture_atlas_1", this.onClickAudioButton, this);
        this.audioOffButton.setFrames( "btn_sound_off", "btn_sound_off", "btn_sound_off", "btn_sound_off");
        this.audioOffButton.anchor.set(.5);
        this.audioOffButton.scale.y = GameVars.scaleY;
        this.add(this.audioOffButton);

        if (GameVars.gameData && GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }

        const scaledItemsContainer = new Phaser.Group(this.game);
        scaledItemsContainer.x = GameConstants.GAME_WIDTH / 2;
        scaledItemsContainer.y = GameConstants.GAME_HEIGHT / 2;
        scaledItemsContainer.scale.y = GameVars.scaleY;
        this.add(scaledItemsContainer);

        const newGameLabel = new Phaser.Image(this.game, 0, -190, "texture_atlas_1", "text_newgame");
        newGameLabel.anchor.set(.5);
        scaledItemsContainer.add(newGameLabel);

        let playButton = new Phaser.Button(this.game, -200, -25, "texture_atlas_1", this.onClickPlay, this);
        playButton.setFrames("btn_sq_easy", "btn_sq_easy", "btn_sq_easy", "btn_sq_easy");
        playButton.anchor.set(.5);
        playButton.name = GameConstants.DIFFICULTY_EASY;
        scaledItemsContainer.add(playButton);

        playButton = new Phaser.Button(this.game, 0, -25, "texture_atlas_1", this.onClickPlay, this);
        playButton.setFrames("btn_sq_medium", "btn_sq_medium", "btn_sq_medium", "btn_sq_medium");
        playButton.anchor.set(.5);
        playButton.name = GameConstants.DIFFICULTY_MEDIUM;
        scaledItemsContainer.add(playButton);

        playButton = new Phaser.Button(this.game, 200, -25, "texture_atlas_1", this.onClickPlay, this);
        playButton.setFrames("btn_sq_hard", "btn_sq_hard", "btn_sq_hard", "btn_sq_hard");
        playButton.anchor.set(.5);
        playButton.name = GameConstants.DIFFICULTY_HARD;
        scaledItemsContainer.add(playButton);

        const easyLabel = new Phaser.Text(this.game, -200, 65, "EASY", {font: "36px Eczar", fill: "#FFFFFF"});
        easyLabel.anchor.set(.5);
        scaledItemsContainer.add(easyLabel);

        const mediumLabel = new Phaser.Text(this.game, 0, 65, "MEDIUM", {font: "36px Eczar", fill: "#FFFFFF"});
        mediumLabel.anchor.set(.5);
        scaledItemsContainer.add(mediumLabel);

        const difficultLabel = new Phaser.Text(this.game, 200, 65, "HARD", {font: "36px Eczar", fill: "#FFFFFF"});
        difficultLabel.anchor.set(.5);
        scaledItemsContainer.add(difficultLabel);

        this.tutorialButton = new Phaser.Button(this.game, 0, difficultLabel.position.y + 150 * GameVars.scaleY, "texture_atlas_1", this.onClickTutorial, this);
        this.tutorialButton.setFrames( "btn_info", "btn_info", "btn_info", "btn_info");
        this.tutorialButton.anchor.set(.5);
        scaledItemsContainer.add(this.tutorialButton);

        this.game.add.tween(tmpBackground)
            .to ({ alpha: .65 }, 450, Phaser.Easing.Cubic.Out, true);
    }

    public closeTutorial(): void {
        this.tutorialLayer.destroy();
        this.tutorialLayer = null;
    }

    private onClickClose(): void {

        BoardManager.resumeGame();

        AudioManager.playSound("btn_click");
    }

    private onClickAudioButton(): void {
        
        AudioManager.toggleAudioState();

        if (GameVars.gameData && GameVars.gameData.muted) {
            this.audioOnButton.visible = false;
            this.audioOffButton.visible = true;
        } else {
            this.audioOnButton.visible = true;
            this.audioOffButton.visible = false;
        }
    }

    private onClickPlay(b: Phaser.Button): void {

        GameManager.enterBoardScene(b.name);

        AudioManager.playSound("btn_click");
    }

    private onClickTutorial(): void {
        this.tutorialLayer = new TutorialLayer(this.game);
        this.add(this.tutorialLayer);
        GameVars.tutorialFromSplash = false;

        AudioManager.playSound("btn_click");
    }
}
